import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { AppStateType } from '../../../../bll/store'
import Operators from './operators'
import { addOperator, clearOperators, editAccessLevel, getOperators, updateOperatorData } from '../../../../bll/settings/settingOperations'
import { Loader } from 'rsuite'
import openNotification from '../../../_ui/notification'
import errorHandler from '../../../../bll/errorHandler'

const OperatorsContainer = (props: any) => {
    const navigate = useNavigate()

    const [isVisibleLoader, setIsVisibleLoader] = React.useState(false) // Видимость компоненты Loader

    const [getFilterOperators, setFilterOperators] = React.useState('') // Фильтр по операторам

    const [selectedOperatorID, setSelectedOperatorID] = React.useState(0) // Идентификатор выбранного оператора
    const [editableAccessLevelID, setEditableAccessLevelID] = React.useState(0) // Идентификатор редактируемого уровня доступа

    const [getAddOperatorVisible, setAddOperatorVisible] = React.useState(false) // Видимость окна добавление нового оператора
    const [getAccessLevelUmkdVisible, setAccessLevelUmkdVisible] = React.useState(false) // Видимость окна редактирования уровней доступа УМКД
    const [getAccessLevelPortfolioStudentVisible, setAccessLevelPortfolioStudentVisible] = React.useState(false) // Видимость окна редактирования уровней доступа портфолио студента

    const [getAddLogin, setAddLogin] = React.useState('') // Добавление логина оператора
    const [getAddPassword, setAddPassword] = React.useState('') // Добавление пароля оператора
    const [getAddLastName, setAddLastName] = React.useState('') // Добавление фамилии оператора
    const [getAddFirstName, setAddFirstName] = React.useState('') // Добавление имени оператора
    const [getAddSecondName, setAddSecondName] = React.useState('') // Добавление отчества оператора

    const [getEditLoginVisible, setEditLoginVisible] = React.useState(false) // Видимость окна редактирования пароля оператора
    const [getEditPasswordVisible, setEditPasswordVisible] = React.useState(false) // Видимость окна редактирования логина оператора
    const [getEditFIOVisible, setEditFIOVisible] = React.useState(false) // Видимость окна редактирования ФИО оператора
    const [getEditPositionVisible, setEditPositionVisible] = React.useState(false) // Видимость окна редактирования должности оператора
    const [getEditPhoneVisible, setEditPhoneVisible] = React.useState(false) // Видимость окна редактирования телефона оператора
    const [getEditEmailVisible, setEditEmailVisible] = React.useState(false) // Видимость окна редактирования электронной почты оператора

    const [getEditLogin, setEditLogin] = React.useState('') // Редактирование пароля оператора
    const [getEditPassword, setEditPassword] = React.useState('') // Редактирование логина оператора
    const [getEditLastName, setEditLastName] = React.useState('') // Редактирование фамилии оператора
    const [getEditFirstName, setEditFirstName] = React.useState('') // Редактирование имени оператора
    const [getEditSecondName, setEditSecondName] = React.useState('') // Редактирование отчества оператора
    const [getEditPosition, setEditPosition] = React.useState('') // Редактирование должности оператора
    const [getEditPhone, setEditPhone] = React.useState('') // Редактирование телефона оператора
    const [getEditEmail, setEditEmail] = React.useState('') // Редактирование электронной почты оператора



    React.useEffect(() => {
        if (!props.disabledTab) {
            setIsVisibleLoader(true)

            props.getOperators().then((result: any) => {
                setIsVisibleLoader(false)

                switch (result?.code) {
                    case "ERR_QUERY_STRING": { return openNotification("Список операторов...", props.msg.err_0025, "error", "bottomRight") }
                    default: errorHandler(result?.code, props.msg); break
                }
            })
        } else {
            openNotification("Доступ запрещен...", props.msg.warn_0002, "warning", "bottomRight")
            navigate('/main')
        }

        return () => {
            props.clearOperators()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    // @ts-ignore
    // window._oper = getAccessLevelUmkdVisible

    // Функция по выбору оператора
    const onSelectedOperator = (value: number) => {
        if (selectedOperatorID) { // Если оператор выбран
            if (selectedOperatorID === value) { // Если предыдущей оператор совпадает с текущем выбором
                setSelectedOperatorID(0) // Очищаем идентификатор выбранного оператора
            } else {
                setSelectedOperatorID(value) // Устанавливаем идентификатор выбранного оператора
            }
        } else {
            setSelectedOperatorID(value) // Устанавливаем идентификатор выбранного оператора
        }
    }

    // Функция изменения уровня доступа оператора
    const onChangeAccessLevelOperator = (accessLevelID: any, isChecked: boolean) => {
        let currentOperatorList = [...props.operatorsList]

        currentOperatorList.forEach(operator => {
            if (operator.loginID === selectedOperatorID) {
                operator.accessLevelList.forEach((accessLevel: any) => {
                    if (accessLevel.accessLevelID === accessLevelID) {
                        accessLevel.isChecked = isChecked
                    }
                })
            }
        })

        props.editAccessLevel(selectedOperatorID, accessLevelID, isChecked, currentOperatorList).then((result: any) => {
            switch (result?.code) {
                case "ERR_QUERY_STRING": { return openNotification("Список операторов...", props.msg.err_0026, "error", "bottomRight") }
                default: errorHandler(result?.code, props.msg); break
            }
        })
    }

    // Функция открытия окна редактирования уровня доступа, в зависимости от идентификатора
    const onClickOpenEditAccessLevel = (accessLevelID: number) => {
        switch (accessLevelID) {
            case 1: setAccessLevelUmkdVisible(true); break
            case 3: setAccessLevelPortfolioStudentVisible(true); break

            default: return
        }

        setEditableAccessLevelID(accessLevelID) // Устанавливаем идентификатор редактируемого уровня доступа
    }

    // Функция закрытия окна редактирования уровня доступа, в зависимости от идентификатора
    const onClickCloseEditAccessLevel = () => {
        switch (editableAccessLevelID) {
            case 1: setAccessLevelUmkdVisible(false); break
            case 3: setAccessLevelPortfolioStudentVisible(false); break

            default: return
        }

        setEditableAccessLevelID(0) // Очищаем идентификатор редактируемого уровня доступа
    }


    // Кнопка сгенерировать новый пароль
    const generatePassword = (fieldType: any) => {
        var length = 8, charset = "1234567890@!*$", retVal = ""

        for (var i = 0, n = charset.length; i < length; ++i) {
            retVal += charset.charAt(Math.floor(Math.random() * n))
        }

        if (fieldType === "addOperator") {
            setAddPassword(retVal)
        } else {
            setEditPassword(retVal)
        }
    }

    // Кнопка закрыть окно добавления оператора
    const onClickButtonCancelOperator = () => {
        setAddLogin('')
        setAddPassword('')
        setAddLastName('')
        setAddFirstName('')
        setAddSecondName('')

        setAddOperatorVisible(false)
    }

    // Кнопка добавить нового оператора
    const onClickButtonAddOperator = () => {
        let errorForm = false

        if (getAddLogin.trim().length < 2) {
            errorForm = true
            openNotification("Логин оператора...", "Должно быть не меньше двух символов и не может быть пустым.", "warning", "bottomRight")
        }

        if (getAddPassword.trim().length === 0) {
            errorForm = true
            openNotification("Пароль оператора...", "Не может быть пустым.", "warning", "bottomRight")
        }

        if (getAddLastName.trim().length < 2) {
            errorForm = true
            openNotification("Фамилия оператора...", "Должно быть не меньше двух символов и не может быть пустым.", "warning", "bottomRight")
        }

        if (getAddFirstName.trim().length < 2) {
            errorForm = true
            openNotification("Имя оператора...", "Должно быть не меньше двух символов и не может быть пустым.", "warning", "bottomRight")
        }

        // Если ошибок не обнаружено
        if (!errorForm) {
            const newUser = {
                loginName: getAddLogin,
                loginPassword: getAddPassword,
                userLastName: getAddLastName,
                userFirstName: getAddFirstName,
                userSecondName: getAddSecondName
            }

            // Добавляем нового оператора
            props.addOperator(newUser).then((result: any) => {
                let isErrorUser = true

                switch (result?.code) {
                    case "OK": isErrorUser = false; break
                    case "ERR_QUERY_STRING": { return openNotification("Добавление оператора...", props.msg.err_0035, "error", "bottomRight") }
                    case "ERR_OPERATOR_NAME": { return openNotification("Добавление оператора...", "Оператор с таким логином уже зарегистрирован в системе.", "warning", "bottomRight") }
                    default: errorHandler(result?.code, props.msg); break
                }

                if (!isErrorUser) {
                    setAddLogin('')
                    setAddPassword('')
                    setAddLastName('')
                    setAddFirstName('')
                    setAddSecondName('')

                    setAddOperatorVisible(false) // Закрываем текущее окно
                }
            })
        }
    }

    // Кнопка сохранить - при редактировании данных оператора
    const onClickButtonSaveDataUser = (fieldType: string) => {
        let fieldValue = "", feildErr = false
        let operatorFIO: any

        if (fieldType === "login") {
            if (getEditLogin.trim().length === 0) {
                feildErr = true
                openNotification("Логин оператора...", "Поле не может быть пустым", "warning", "bottomRight")
            } else { fieldValue = getEditLogin }
        }

        if (fieldType === "password") { 
            if (getEditPassword.trim().length < 8) {
                feildErr = true
                openNotification("Пароль оператора...", "Пароль должен быть не менее 8ми символов", "warning", "bottomRight")
            } else { fieldValue = getEditPassword  }
        }

        if (fieldType === "fio") {
            if (getEditLastName.trim().length === 0) {
                feildErr = true
                openNotification("Фамилия оператора...", "Поле не может быть пустым", "warning", "bottomRight")
            }

            if (getEditFirstName.trim().length === 0) {
                feildErr = true
                openNotification("Имя оператора...", "Поле не может быть пустым", "warning", "bottomRight")
            }

            if (!feildErr) {
                operatorFIO = {
                    lastName: getEditLastName.trim(),
                    firstName: getEditFirstName.trim(),
                    secondName: getEditSecondName.trim()
                }
            }
        }

        if (fieldType === "position") {
            if (getEditPosition.trim().length === 0) {
                feildErr = true
                openNotification("Должность оператора...", "Поле не может быть пустым", "warning", "bottomRight")
            } else { fieldValue = getEditPosition }
        }

        if (fieldType === "phone") {
            if (getEditPhone.trim().length === 0) {
                feildErr = true
                openNotification("Номер телефона...", "Поле не может быть пустым", "warning", "bottomRight")
            } else { 
                const regexPhoneNumber = new RegExp(`^[0-9]{10}$`)
                if (!regexPhoneNumber.test(getEditPhone.trim())) {
                    feildErr = true
                    openNotification("Номер телефона...", `Номер телефона может содержать только цифры и должен быть не меньше 10 символов (БЕЗ +7 и 8 в начале).`, "warning", "bottomRight")
                } else { fieldValue = getEditPhone }
            }
        }

        if (fieldType === "email") {
            if (getEditEmail.trim().length === 0) {
                feildErr = true
                openNotification("Электронная почта...", "Поле не может быть пустым", "warning", "bottomRight")
            } else { 
                const regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                if (!regexEmail.test(getEditEmail)) {
                    feildErr = true
                    openNotification("Электронная почта...", `Электронная почта оператора не корректна`, "warning", "bottomRight")
                } else { fieldValue = getEditEmail }
            }
        }


        // Если ошибок не обнаружено, выполняем запрос на сервер
        if (!feildErr) {
            props.updateOperatorData(selectedOperatorID, fieldType, fieldValue.trim(), operatorFIO).then((result: any) => {
                let isErrorData = true

                switch (result?.code) {
                    case "OK": isErrorData = false; break
                    case "ERR_QUERY_STRING": { return openNotification("Редактирование данных...", props.msg.err_0036, "error", "bottomRight") }
                    default: errorHandler(result?.code, props.msg); break
                }

                if (!isErrorData) {
                    switch (fieldType) {
                        case 'login': setEditLogin(''); setEditLoginVisible(false); break
                        case 'password': setEditPassword(''); setEditPasswordVisible(false); break
                        case 'fio': setEditLastName(''); setEditFirstName(''); setEditSecondName(''); setEditFIOVisible(false); break
                        case 'position': setEditPosition(''); setEditPositionVisible(false); break
                        case 'phone': setEditPhone(''); setEditPhoneVisible(false); break
                        case 'email': setEditEmail(''); setEditEmailVisible(false); break
                    }
                }
            })
        }
    }


    // Свойства передаваемые к компоненту
    const propsToOperators = {
        getFilterOperators, setFilterOperators, // Фильтр по операторам
        onSelectedOperator, // Функция по выбору оператора
        selectedOperatorID, // Идентификатор выбранного оператора

        onChangeAccessLevelOperator, // Функция изменения уровня доступа оператора
        onClickOpenEditAccessLevel, onClickCloseEditAccessLevel, // Функция открытия (закрытия) окна редактирования уровня доступа, в зависимости от идентификатора

        onClickButtonCancelOperator, // Кнопка закрыть окно добавления оператора
        onClickButtonAddOperator, // Кнопка добавить нового оператора
        onClickButtonSaveDataUser, // Кнопка сохранить - при редактировании данных оператора
        generatePassword, // Кнопка сгенерировать новый пароль
        getAddLogin, setAddLogin, // Добавление логина оператора
        getAddPassword, setAddPassword, // Добавление пароля оператора
        getAddLastName, setAddLastName, // Добавление фамилии оператора
        getAddFirstName, setAddFirstName, // Добавление имени оператора
        getAddSecondName, setAddSecondName, // Добавление отчества оператора

        getAddOperatorVisible, setAddOperatorVisible, // Видимость окна добавление нового оператора
        getAccessLevelUmkdVisible, // Видимость окна редактирования уровней доступа УМКД
        getAccessLevelPortfolioStudentVisible, // Видимость окна редактирования уровней доступа портфолио студента

        getEditLoginVisible, setEditLoginVisible, // Видимость окна редактирования пароля оператора
        getEditPasswordVisible, setEditPasswordVisible, // Видимость окна редактирования логина оператора
        getEditFIOVisible, setEditFIOVisible, // Видимость окна редактирования ФИО оператора
        getEditPositionVisible, setEditPositionVisible, // Видимость окна редактирования должности оператора
        getEditPhoneVisible, setEditPhoneVisible, // Видимость окна редактирования телефона оператора
        getEditEmailVisible, setEditEmailVisible, // Видимость окна редактирования электронной почты оператора

        getEditLogin, setEditLogin, // Редактирование пароля оператора
        getEditPassword, setEditPassword, // Редактирование логина оператора
        getEditLastName, setEditLastName, // Редактирование фамилии оператора
        getEditFirstName, setEditFirstName, // Редактирование имени оператора
        getEditSecondName, setEditSecondName, // Редактирование отчества оператора
        getEditPosition, setEditPosition, // Редактирование должности оператора
        getEditPhone, setEditPhone, // Редактирование телефона оператора
        getEditEmail, setEditEmail, // Редактирование электронной почты оператора
    }

    return (
        <>
            {isVisibleLoader
                ? <div style={{ height: "100%", position: "relative" }}><Loader center size="md" content="Загрузка данных..." vertical /> </div>
                : <Operators {...props} {...propsToOperators} />
            }
        </>
    )
}

let mapState = (state: AppStateType) => {
    return {
        msg: state.msg,
        operatorsList: state.settings.operatorsList,
    }
}

export default compose(connect(mapState, {
    addOperator, updateOperatorData, getOperators, clearOperators, editAccessLevel,
}))(OperatorsContainer)